import { Injectable } from '@angular/core';
import { NotificationSettings } from '@progress/kendo-angular-notification';

@Injectable()
export class NotificationBodyService {

    base: NotificationSettings = {
        content: '',
        hideAfter: 6000,
        position: { horizontal: 'right', vertical: 'top' }
    };

    error(message): NotificationSettings {
        this.base.content = message;
        this.base.type = { style: 'error', icon: true };

        return this.base;
    }

    success(message): NotificationSettings {
        this.base.content = message;
        this.base.type = { style: 'success', icon: true };

        return this.base;
    }

    info(message): NotificationSettings {
        this.base.content = message;
        this.base.type = { style: 'info', icon: true };

        return this.base;
    }

}
